import { z } from 'zod';

import {
  submissionSchema,
  type ApplicationSubmission
} from '../provider/applications';
import {
  getProviderJson,
  postProviderJson,
  putProviderJson
} from '../providerClient';

const myApplicationListSchema = z.object({
  items: z.array(submissionSchema)
});

export const getMyApplications = () =>
  getProviderJson('/me/applications', { schema: myApplicationListSchema });

export type ApplicationAnswerInput = {
  questionIndex: number;
  answerText?: string | null;
  answerJson?: string[] | boolean | number | null;
};

export const getMyApplication = (id: number) =>
  getProviderJson(`/me/applications/${id}`, { schema: submissionSchema });

export const saveMyApplicationAnswers = (
  id: number,
  answers: ApplicationAnswerInput[]
) =>
  putProviderJson(
    `/me/applications/${id}/answers`,
    { answers },
    { schema: submissionSchema }
  );

export const submitMyApplication = (
  id: number,
  answers: ApplicationAnswerInput[]
) =>
  postProviderJson(
    `/me/applications/${id}/submit`,
    { answers },
    { schema: submissionSchema }
  );

export type { ApplicationSubmission };
